export default __webpack_public_path__ + "static/N0215-96771f5ab7caaf1e0fb111b16f8b21e0.png";